import { useEffect, useRef, useState } from "react";
import { Button, Grid } from "@mui/material";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { axiosAPIWithJson, axiosGet } from "../../util/axios";
import {
  OpenSnackBarWithResultFail,
  OpenSnackBarWithResultSuccess,
} from "../../redux/common/snackBar/thunk";
import {
  initBinPeopleCounterListAction,
  initTargetBinPeopleCounterAction,
  clearTargetBinPeopleCounterAction,
} from "../../redux/peopleCounter/action";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Cancel, CheckCircle, EditNote } from "@mui/icons-material";
import { ButtonTextGrid } from "../..";
import { BinPeopleCounter } from "../../redux/peopleCounter/state";
import FormDialog from "../../component/common/FormDialog";
import moment from "moment";
import PeopleCounterForm from "../../component/peopleCounter/PeopleCounterForm";

function PeopleCounter() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const dataFetchedRef = useRef(false);
  const [openDialog, setOpenDialog] = useState(false);

  const { binPeopleCounterList, targetBinPeopleCounter } = useSelector(
    (state: IRootState) => state.peopleCounterState,
  );

  useEffect(() => {
    const controller = new AbortController();
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    getToiletPeopleCounterQuery();
    return () => {
      controller.abort();
    };
  }, []);

  async function getToiletPeopleCounterQuery() {
    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosGet("/api/cleaning/peopleCouner");
    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(
        initBinPeopleCounterListAction(result.data.binPeopleCounterList),
      );
    } else {
      dispatch(OpenSnackBarWithResultFail("無法下載人流統計器"));
    }
  }

  function handleEditPeopleCounter(row: BinPeopleCounter) {
    dispatch(initTargetBinPeopleCounterAction(row));
    setOpenDialog(true);
  }

  function handleCloseDialog() {
    setOpenDialog(false);
    dispatch(clearTargetBinPeopleCounterAction());
  }

  async function handleSubmitPeopleCounter() {
    // TODO: Add API call to save data

    if (!targetBinPeopleCounter.bin_people_counter) {
      dispatch(OpenSnackBarWithResultFail("你未有更改人流統計器"));
      return;
    }

    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosAPIWithJson.post(
      `/api/cleaning/reset/peopleCouner`,
      targetBinPeopleCounter,
    );
    if (result.data.success) {
      dispatch(OpenSnackBarWithResultSuccess(result.data.message));
      getToiletPeopleCounterQuery();
      dispatch(OpenLoadingBarThunk(false));
    } else {
      dispatch(OpenSnackBarWithResultFail(result?.data.message));
    }

    handleCloseDialog();
  }

  const columns: GridColDef[] = [
    { field: "bin_people_counter_id", headerName: "編號", flex: 1 },
    { field: "bin_full_name", headerName: "廁所名稱", flex: 3 },
    { field: "bin_people_counter", headerName: "人流計數", flex: 1 },
    {
      field: "is_reset",
      headerName: "重置狀態",
      flex: 1,
      renderCell: (data) => (
        <div>
          {data.value === 0 ? (
            <Cancel style={{ color: "red" }} />
          ) : (
            <CheckCircle style={{ color: "green" }} />
          )}
        </div>
      ),
    },
    {
      field: "created_date",
      headerName: "建立日期",
      flex: 2,
      renderCell: (data) => (
        <div>
          {data.value
            ? moment(parseInt(data.value)).format("YYYY-MM-DD HH:mm:ss")
            : null}
        </div>
      ),
    },
    {
      field: "updated_date",
      headerName: "更新日期",
      flex: 2,
      renderCell: (data) => (
        <div>
          {data.value
            ? moment(parseInt(data.value)).format("YYYY-MM-DD HH:mm:ss")
            : null}
        </div>
      ),
    },
    {
      field: "action",
      headerName: "操作",
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => handleEditPeopleCounter(params.row)}
        >
          <ButtonTextGrid>
            <EditNote />
            <Grid>詳情</Grid>
          </ButtonTextGrid>
        </Button>
      ),
    },
  ];

  return (
    <Grid>
      <div style={{ height: "900px", width: "100%" }}>
        <DataGrid
          rows={binPeopleCounterList || []}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 30 },
            },
          }}
          pageSizeOptions={[5, 10, 30]}
          checkboxSelection
          getRowId={(row) => row.bin_people_counter_id}
        />
      </div>

      <FormDialog
        title="更改人流統計器"
        open={openDialog}
        handleClose={handleCloseDialog}
        handleSubmit={handleSubmitPeopleCounter}
        size="lg"
      >
        <Grid padding={1}>
          <PeopleCounterForm />
        </Grid>
      </FormDialog>
    </Grid>
  );
}

export default PeopleCounter;
